export const fontGroups = [
  {
    label: "Standard",
    fonts: [
      {
        name: "Default (Nunito)",
        value: "Nunito",
        google: "Nunito:wght@400;700",
      },
      { name: "Roboto", value: "Roboto", google: "Roboto:wght@400;700" },
      {
        name: "IBM Plex Sans",
        value: "IBM Plex Sans",
        google: "IBM+Plex+Sans:wght@400;700",
      },
      {
        name: "Atkinson Hyperlegible",
        value: "Atkinson Hyperlegible",
        google: "Atkinson+Hyperlegible",
      },
    ],
  },
  {
    label: "Thin & Elegant",
    fonts: [
      { name: "Dosis", value: "Dosis", google: "Dosis:wght@400;700" },
      { name: "Poppins", value: "Poppins", google: "Poppins:wght@400;700" },
      {
        name: "Montserrat",
        value: "Montserrat",
        google: "Montserrat:wght@400;700",
      },
      { name: "Raleway", value: "Raleway", google: "Raleway:wght@400;700" },
    ],
  },
  {
    label: "Bold & Strong",
    fonts: [
      { name: "Anton", value: "Anton", google: "Anton" },
      {
        name: "Archivo Black",
        value: "Archivo Black",
        google: "Archivo+Black",
      },
      { name: "Bebas Neue", value: "Bebas Neue", google: "Bebas+Neue" },
      { name: "Teko", value: "Teko", google: "Teko:wght@400;700" },
    ],
  },
];
